// extracted by mini-css-extract-plugin
var _1 = "InputTabs-module__active--Xtju5";
var _2 = "InputTabs-module__animatedBackground--EF8Z_";
var _3 = "InputTabs-module__container--Kap5Q";
var _4 = "InputTabs-module__inputContainer--WuFeX";
var _5 = "InputTabs-module__list--QPG1g";
var _6 = "InputTabs-module__saveButton--NVx68";
var _7 = "InputTabs-module__tabItem--e0R9M";
export { _1 as "active", _2 as "animatedBackground", _3 as "container", _4 as "inputContainer", _5 as "list", _6 as "saveButton", _7 as "tabItem" }
